import React from 'react';
import { Avatar, RadioGroup, RadioBox as Radio } from '@jjj/components';
import { TextCell } from '../../../../../../../components/tables/helperCells';
import { getLogo } from '../../../../../../../helpers/image';
import { t } from '../../../../../../../i18n';
import { AvatarWrapper, RadioGroupWrapper } from '../addApplicantModal.style';

export function getColumns(selectedTalent, onChange) {
  return [
    {
      title: t('dash.units.unit.myTeam.columns.first_name_title'),
      key: 'first_name',
      width: '45%',
      render: (object, url) => (
        <AvatarWrapper>
          <Avatar src={object.avatar_url} useDefaultAvatar />
          {getLogo(object?.organization)}
          {TextCell(object.first_name, url)}
        </AvatarWrapper>
      ),
    },
    {
      title: t('dash.units.unit.myTeam.columns.last_name_title'),
      key: 'last_name',
      width: '45%',
      render: (object, url) => TextCell(object.last_name, url),
    },
    {
      title: '',
      key: 'is-selected',
      width: '10%',
      render: object => (
        <RadioGroupWrapper>
          <RadioGroup
            defaultValue={false}
            onChange={() => onChange({ attr: 'talent', value: object.id })}
            value={selectedTalent === object.id}
          >
            <Radio value />
          </RadioGroup>
        </RadioGroupWrapper>
      ),
    },
  ];
}
